(function () {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function initReviews(root) {
    const slider = root.querySelector('[data-et-gl3-rv-slider]');
    if (!slider || slider.dataset.etGl3Init) return;
    slider.dataset.etGl3Init = 'true';

    const scrollbar = root.querySelector('.et-gl3-rv__scrollbar');
    let swiper = null;

    const update = () => {
      if (typeof window.Swiper === 'undefined') return;

      if (MOBILE_QUERY.matches && !swiper) {
        swiper = new window.Swiper(slider, {
          wrapperClass: 'et-gl3-rv__list',
          slideClass: 'et-gl3-rv__card',
          slidesPerView: 'auto',
          spaceBetween: 8,
          slidesOffsetAfter: 16,
          watchOverflow: true,
          scrollbar: scrollbar ? { el: scrollbar, draggable: true } : false,
        });
      } else if (!MOBILE_QUERY.matches && swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    };

    update();
    MOBILE_QUERY.addEventListener('change', update);

    slider.etGl3Destroy = () => {
      MOBILE_QUERY.removeEventListener('change', update);
      if (swiper) swiper.destroy(true, true);
      swiper = null;
    };
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-et-gl3-reviews]').forEach(initReviews);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-et-gl3-rv-slider]').forEach((slider) => {
      if (typeof slider.etGl3Destroy === 'function') slider.etGl3Destroy();
    });
  });
})();
